import { render, staticRenderFns } from "./Competitors.vue?vue&type=template&id=34a8cbcd&"
import script from "./Competitors.vue?vue&type=script&lang=js&"
export * from "./Competitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a8cbcd')) {
      api.createRecord('34a8cbcd', component.options)
    } else {
      api.reload('34a8cbcd', component.options)
    }
    module.hot.accept("./Competitors.vue?vue&type=template&id=34a8cbcd&", function () {
      api.rerender('34a8cbcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Research/Competitors.vue"
export default component.exports